import { Box, Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { ErrorCardVariant } from "./error-card.helpers";

const ERROR_CARD_COPY: Record<ErrorCardVariant, { title: string; description: string }> = {
  "invalid-invite": {
    title: "This invitation can't be opened",
    description: "The link may be incorrect or no longer valid. Ask your buyer contact to send a new invitation.",
  },
  network: {
    title: "We couldn't reach the server",
    description: "Check your connection and try again.",
  },
};

export const ErrorCard = ({ variant, action }: { variant: ErrorCardVariant; action?: ReactNode }): ReactElement => {
  const { title, description } = ERROR_CARD_COPY[variant];
  return (
    <Box
      sx={{
        maxWidth: 560,
        width: "100%",
        borderRadius: 2,
        border: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        px: 4,
        py: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="h4" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {description}
      </Typography>
      {action && <Box sx={{ mt: 4 }}>{action}</Box>}
    </Box>
  );
};
